import React, { useMemo } from 'react';

function formatMinutesToShortHours(minutes) {
  const m = Math.max(0, Number(minutes) || 0);
  const h = m / 60;
  if (h >= 10) return `${Math.round(h)}h`;
  if (h >= 1) return `${h.toFixed(1).replace('.', ',')}h`;
  return `${Math.round(m)} min`;
}

export default function TaskDetailBlock({ title, items, barClassName = 'bg-emerald-600', hideZero = true }) {
  const filtered = useMemo(() => {
    const arr = Array.isArray(items) ? items : [];
    const withNumbers = arr.map((t) => ({
      ...t,
      minutes_per_week: Number(t.minutes_per_week) || 0,
      burden_score: Number(t.burden_score) || 0
    }));
    const nonZero = hideZero ? withNumbers.filter((t) => t.minutes_per_week > 0.001) : withNumbers;
    return nonZero.sort((a, b) => b.minutes_per_week - a.minutes_per_week);
  }, [items, hideZero]);

  const max = useMemo(() => {
    return filtered.reduce((acc, t) => Math.max(acc, t.minutes_per_week || 0), 0);
  }, [filtered]);

  if (!filtered || filtered.length === 0) {
    return (
      <div className="p-4 text-center text-sm text-ptcm-muted dark:text-gray-400">
        Aucune tâche avec du temps calculable pour le moment.
      </div>
    );
  }

  // Helper to get burden label and color
  const getBurdenInfo = (score) => {
    // 4: Me pèse beaucoup
    if (score >= 4) return { label: 'Me pèse beaucoup', color: 'text-red-600 bg-red-50 dark:bg-red-900/20 dark:text-red-400' };
    // 3: Me pèse un peu
    if (score >= 3) return { label: 'Me pèse un peu', color: 'text-orange-600 bg-orange-50 dark:bg-orange-900/20 dark:text-orange-400' };
    // 2: Ne me pèse pas
    if (score >= 2) return { label: 'Ne me pèse pas', color: 'text-ptcm-primary bg-ptcm-primary-soft dark:bg-blue-900/20 dark:text-blue-400' };
    // 1: J'aime
    if (score >= 1) return { label: "J'aime", color: 'text-emerald-700 bg-ptcm-mint/70 dark:bg-emerald-900/20 dark:text-emerald-400' };
    
    // 0 or undefined
    return { label: '-', color: 'text-ptcm-muted bg-ptcm-panel dark:bg-gray-800 dark:text-gray-500' };
  };

  return (
    <div className="space-y-4">
      {filtered.map((t) => {
        const burden = getBurdenInfo(t.burden_score);
        const p = max > 0 ? (t.minutes_per_week / max) * 100 : 0;

        return (
          <div key={t.question_uuid} className="space-y-1">
            <div className="flex items-start justify-between gap-3">
              <div className="space-y-0.5">
                <div className="text-sm font-medium text-ptcm-ink dark:text-gray-100">{t.question_label}</div>
                <div className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ${burden.color}`}>
                  {burden.label}
                </div>
              </div>
              <div className="text-sm font-bold text-ptcm-ink dark:text-gray-100 whitespace-nowrap">
                {formatMinutesToShortHours(t.minutes_per_week)}
              </div>
            </div>
            <div className="w-full h-2 bg-ptcm-panel dark:bg-gray-800 rounded-full overflow-hidden">
              <div className={`h-2 rounded-full ${barClassName}`} style={{ width: `${p}%` }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

